import t from"react";import"../../node_modules/antd/es/statistic/index.js";import e from"../../node_modules/antd/es/statistic/Statistic.js";const{Countdown:o}=e,s=({sec:e,...s})=>t.createElement(o,{value:Date.now()+1e3*e,...s});export{s as Countdown,s as default};
//# sourceMappingURL=index.js.map
